// Used in many components

// Angular
import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild,
} from "@angular/core";

// Services/Types/Helpers
import { LocalStorage } from "#services/local-storage.service";
// RXJS/Store
import { ServerSidePaginationParams } from "@carnegie-learning/data-access-angular-passport";
import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";

@Component({
    selector: "search-field",
    templateUrl: "./search.component.html",
    styleUrls: ["./search.component.scss"],
    standalone: false
})
export class SearchComponent implements OnInit, OnChanges {
    apiSearchString: string | null = null;
    searchStringChanged$ = new Subject<string>();
    initialLoad = true;

    @Input() background = "#0000000d";
    @Input() placeholder = "Search";
    @Input() suppressLabel: boolean;
    @Input() searchLabel: string;
    @Input() searchLabelWhite: boolean;
    @Input() savedContentLibraryParams: any; // AssignablePaginationParameters
    @Input() savedResourcesParams: any; // SpinePaginationParameters

    @Input() loading: boolean;
    @Input() paginationParams: ServerSidePaginationParams;
    @Input() searchWidth: string;

    @Input() searchLabelQualifier: string;
    @Input() searchLabelQualifierClass: string;
    @Input() isStudent: boolean;

    @Output() apiSearchStringChanged = new EventEmitter();

    @ViewChild("searchBox") private elementRef: ElementRef;

    constructor(private localStorage: LocalStorage) {
        this.searchStringChanged$
            .pipe(debounceTime(1000), distinctUntilChanged())
            .subscribe((model) => {
                this.apiSearchString = model;
                this.apiSearchStringChanged.emit(this.apiSearchString);
            });
    }

    ngOnInit() {
        if (this.savedContentLibraryParams) {
            this.apiSearchString = this.savedContentLibraryParams.search;
        } else if (this.savedResourcesParams) {
            this.apiSearchString = this.savedResourcesParams.search;
        } else if (this.paginationParams) {
            this.apiSearchString = this.paginationParams.search;
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.initialLoad && this.savedContentLibraryParams) {
            this.apiSearchString = this.savedContentLibraryParams.search;
        } else if (this.initialLoad && this.savedResourcesParams) {
            this.apiSearchString = this.savedResourcesParams.search;
        } else if (this.initialLoad) {
            this.apiSearchString = "";
        }
        if (changes.paginationParams?.currentValue) {
            const paramChanges = changes.paginationParams?.currentValue,
                searchString = paramChanges.filter?.displayName
                    ? paramChanges.filter.displayName
                    : paramChanges.search;
            // in available media for creating a perform activity, the search string is on the filter property. On the homepage it's just "search"
            if (!this.initialLoad && this.apiSearchString && !searchString) {
                this.clearSearchFilter();
            }
        }
        this.initialLoad = false;
    }

    applySearchFilter(value: string) {
        this.searchStringChanged$.next(value.trim().toLowerCase());
    }

    clearSearchFilter() {
        this.apiSearchString = "";
        this.searchStringChanged$.next(
            this.apiSearchString.trim().toLowerCase()
        );
    }

    setApiSearchString(searchString: string) {
        this.apiSearchString = searchString;
    }
}
